import React from 'react' 
import { LoaderLine, Loading } from 'src/libs/useful'
import { LOADER_ANIMATION_TYPE } from 'src/libs/useful/Loading'

export interface IFeedLayoutProps {
    layoutComponent?: any
    children: JSX.Element | string
    isLoading? : boolean
}
const FeedLayout = ( props: IFeedLayoutProps ): JSX.Element => {
    const Layout  = props.layoutComponent
        ?
        props.layoutComponent
        :
        DefaultFeedLayout
    return <Layout { ...props }> 
        { props.children }
    </Layout> 
}

export default FeedLayout

export interface IDefaultFeedLayoutProps extends IFeedLayoutProps {
    containerClassName?: string
    class_name?: string
    style?: React.CSSProperties
    children: JSX.Element | string
}
const DefaultFeedLayout = (props:IDefaultFeedLayoutProps): JSX.Element => {
    return <div className={ ` ${props.containerClassName || " d-flex position-relative" } ` } data-testid="feed-layout-cont"> 
        <div className={ `row ${props.class_name}`  } style={ props.style }>
            { props.children }
        </div> 
        {
            props.isLoading && 
            <div className="w-100 h-100 flex-centered top left position-absolute">
                <div style={{ transform: 'translateX(7px) translateY(-3px)', width: '80px', height: '20px', background: 'var(--force-plain-color)', borderRadius: 10 } } />
                <div className="position-absolute">
                    <LoaderLine animation_type={ LOADER_ANIMATION_TYPE.HORIZONTAL } height={50} />
                </div>
            </div>
        }
    </div> 
}